import React, { useState, useRef, useCallback, useEffect } from 'react';
import styled from 'styled-components/macro';

import useScrollStore from '../../../common/store/useScrollStore';
import MenuIcon, { Wrapper as _MenuIcon } from '../../../common/components/svg/Menu';
import useAnimation from './useAnimation';
import Overlay from './Overlay';

const Wrapper = styled.div(({ $display }: { $display: boolean }) => `
  position: fixed;
  z-index: 20;
  top: 5%;
  right: 5%;

  display: ${$display ? "block" : "none"};
  cursor: pointer;

  ${_MenuIcon} {
    position: relative;
    z-index: 20;
    height: 30rem;

    opacity: 0;
    display: none;
  }
`);

const Menu = ({ display }: { display: boolean }) => {

  const ref = useRef<SVGSVGElement>(null);

  const lockScroll = useScrollStore(useCallback(state => state.lockScroll, []));
  const unlockScroll = useScrollStore(useCallback(state => state.unlockScroll, []));

  const [show, setShow] = useState(false);

  useAnimation(ref);

  useEffect(() => {
    show ? lockScroll() : unlockScroll();
  }, [show, lockScroll, unlockScroll]);

  useEffect(() => {
    !display && setShow(false);
  }, [display]);

  return (
    <Wrapper
      onClick={() => setShow(!show)}
      $display={display}
    >
      <MenuIcon
        ref={ref}
        active={show}
      />
      <Overlay
        active={show}
        setShow={setShow}
      />
    </Wrapper>
  );
}

export default Menu;